import type { TOC } from '@ember/component/template-only';
import { PrismBreadcrumb } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SettingsCentralMappingRoomtypeMapping from 'lumen/components/settings/central-mapping/roomtype-mapping';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsCentralMappingChannelRoomCategoriesController from 'lumen/controllers/hotel/settings/central-mapping/channel-room-categories';

interface HotelSettingsCentralMappingChannelRoomCategoriesSignature {
  Args: {
    controller: HotelSettingsCentralMappingChannelRoomCategoriesController;
    model: unknown;
  };
}

<template>
  <SettingsPageTemplate
    @description={{t "settings.central_mapping.menu.description.channel_rooms"}}
    @isFullHeight={{true}}
    @title={{t "settings.central_mapping.channel_rooms"}}
    class="central-mapping"
  >
    <:breadcrumb>
      <PrismBreadcrumb as |B|>
        <B.item
          @label={{t "settings.pms_mapping.mapping"}}
          @route="hotel.settings.central-mapping.menu"
        />
        <B.item
          @isCurrent={{true}}
          @label={{t "settings.central_mapping.channel_rooms"}}
        />
      </PrismBreadcrumb>
    </:breadcrumb>

    <:default>
      <SettingsCentralMappingRoomtypeMapping
        @canSelectOTA={{@controller.canSelectOTA}}
        @chooseOTA={{@controller.chooseOTA}}
        @dataType={{@controller.dataType}}
        @doRefresh={{@controller.doRefresh}}
        @isRatePreferenceLoading={{@controller.isRatePreferenceLoading}}
        @isRoomtypeRequestLoading={{@controller.isRoomtypeRequestLoading}}
        @otaId={{@controller.ota}}
        @roomtypes={{@controller.roomtypes}}
        @selectedOTA={{@controller.selectedOTA}}
      />
    </:default>
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsCentralMappingChannelRoomCategoriesSignature>;
